import type { NextPage } from 'next';
import Link from 'next/link';
import styles from './bread-crumbs.module.scss';

export type BreadCrumbsType = {
  className?: string;
  items: {
    title: string;
    href: string;
  }[];
};

const BreadCrumbs: NextPage<BreadCrumbsType> = ({
  className = '',
  items = [],
}) => {
  const limitedItems = items.slice(0, 3);

  return (
    <nav
      className={[styles.breadcrumbs, className].join(' ')}
      aria-label="breadcrumb"
    >
      <div className="container">
        <ol className={styles.list}>
          {limitedItems.map((item, index) => (
            <li key={item.href} className={styles.item}>
              <Link href={item.href} className={styles.link}>
                {item.title}
              </Link>
              {index < limitedItems.length - 1 && (
                <span className={styles.separator}>{'>'}</span>
              )}
            </li>
          ))}
        </ol>
      </div>
    </nav>
  );
};

export default BreadCrumbs;
